import { render, staticRenderFns } from "./huodong2.vue?vue&type=template&id=13685d1f&scoped=true&"
import script from "./huodong2.vue?vue&type=script&lang=js&"
export * from "./huodong2.vue?vue&type=script&lang=js&"
import style0 from "./huodong2.vue?vue&type=style&index=0&id=13685d1f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13685d1f",
  null
  
)

export default component.exports